import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import { motion, useInView } from "framer-motion";

const concertItems = [
  { to: "/catalogue/evenement/2much", label: "2Much" },
  { to: "/catalogue/evenement/we-love-green-2k25", label: "We Love Green 2K25" },
  { to: "/catalogue/evenement/peacock", label: "Peacock" },
  { to: "/catalogue/evenement/eclipse3", label: "Eclipse 3" },
  { to: "/catalogue/evenement/nachave", label: "Nachave Présente" },
  { to: "/catalogue/evenement/nava", label: "Nava" },
  { to: "/catalogue/evenement/hdp", label: "Heure De Pointe" },
];

const Concert = () => {
  const listRef = useRef(null);
  const isInView = useInView(listRef, { once: true, margin: "-50px 0px" });

  return (
    <main id="concert">
      <ul id="concert-list" ref={listRef}>
        {concertItems.map((item, index) => (
          <motion.li
            key={item.to}
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: index * 0.1, ease: "easeOut" }}
            style={{ listStyle: "none" }}
          >
            <NavLink to={item.to} className="concert-link">{item.label}</NavLink>
            <div className="concert-separator" style={{opacity: index < concertItems.length - 1 ? 0.3 : 0}} />
          </motion.li>
        ))}
      </ul>
    </main>
  );
};

export default Concert;